module.exports = __webpack_public_path__ + "static/media/LATMALCOTKITX5.a7229ba4.png";